import React from "react"
import TableRow from "./TableRow"

/**
 * The tablebody component will render the table body which uses Tablecell as the subcomponent.
 */

export default function TableBody({
  data,
  onRowClick,
  columns,
  selectedRowId,
  hoveredColumnkey,
  isHover,
  currentPage,
  postPerPage,
  pagination,
  selectableRows,
}) {
  const lastPageIndex = currentPage * postPerPage
  const firstPageIndex = lastPageIndex - postPerPage

  let finaldata = pagination
    ? data.length <= postPerPage
      ? data
      : data.slice(firstPageIndex, lastPageIndex)
    : data
  let domposts = finaldata.map((val, index) => {
    return (
      <TableRow
        key={val.id}
        columns={columns}
        selectableRows={selectableRows}
        hoveredColumnkey={hoveredColumnkey}
        isHover={isHover}
        onRowClick={onRowClick}
        selectedRowId={selectedRowId}
        rowIndex={index}
        rowData={val}
      />
    )
  })

  return <tbody data-testid="tbody">{domposts}</tbody>
}
